"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollMap = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const ScrollArea_1 = require("@jsonjoy.com/ui/lib/4-card/ScrollArea");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const useSyncStore_1 = require("@jsonjoy.com/ui/lib/hooks/useSyncStore");
const scroll_map_1 = require("../../behavior/scroll-map");
const context_2 = require("../../context");
const selectionMarkerBlink = (0, nano_theme_1.keyframes)({
    '0%': { opacity: 1 },
    '50%': { opacity: 0.22 },
    '100%': { opacity: 1 },
});
const selectionMarkerClass = (0, nano_theme_1.rule)({
    // bd: '1px dashed #000',
    bd: '1px dashed #07f',
    bg: 'rgba(7,122,255,.22)',
    bxz: 'border-box',
    minH: '2px',
    trs: 'height .1s ease-out, top .1s ease-out, bottom .1s ease-out',
    animation: `${selectionMarkerBlink} .5s step-start infinite`,
    zIndex: 1,
});
const ScrollMap = ({ editor }) => {
    const state = (0, context_2.useMuTxt)();
    const styles = (0, context_1.useStyles)();
    const scrollArea = (0, ScrollArea_1.useScrollArea)();
    const scrollHeight = (0, useSyncStore_1.useSyncStore)(scrollArea.scrollHeight$);
    const clientHeight = (0, useSyncStore_1.useSyncStore)(scrollArea.clientHeight$);
    const focused = state.focused.use();
    state.wnd.use();
    const version = state.version.use();
    const cursor = state.cursor.use();
    const scrollVersion = state.scrollVersion.use();
    const thingsVersion = state.things.version.use();
    const [markers, setMarkers] = React.useState([]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: focused/version/scrollVersion/cursor are change triggers for re-measuring markers
    React.useLayoutEffect(() => {
        if (!scrollArea.viewportEl || scrollHeight <= clientHeight || scrollHeight <= 0) {
            setMarkers([]);
            return;
        }
        const viewportEl = scrollArea.viewportEl;
        const frame = requestAnimationFrame(() => {
            const railHeight = scrollArea.railEl?.clientHeight ?? clientHeight;
            setMarkers((0, scroll_map_1.measureScrollMapMarkers)(editor, viewportEl, scrollHeight, railHeight, styles.light ?? true, (id) => state.things.get(id)));
        });
        return () => cancelAnimationFrame(frame);
    }, [
        clientHeight,
        editor,
        focused,
        scrollArea,
        scrollHeight,
        styles.light,
        version,
        scrollVersion,
        cursor,
        thingsVersion,
        state,
    ]);
    if (!markers.length)
        return null;
    return (React.createElement(React.Fragment, null, markers.map((marker) => {
        const { variant = 'left' } = marker;
        if (variant === 'selection') {
            return (React.createElement(ScrollArea_1.Marker, { key: marker.key, position: marker.position, height: marker.height }, (markerStyle) => (React.createElement("div", { className: selectionMarkerClass, style: {
                    position: 'absolute',
                    ...markerStyle,
                    left: 0,
                    right: 0,
                    borderRadius: 0,
                } }))));
        }
        return (React.createElement(ScrollArea_1.Marker, { key: marker.key, position: marker.position, color: marker.color, height: marker.height, style: {
                left: variant === 'right' ? 6 : 1,
                right: variant === 'left' ? 6 : 1,
                borderRadius: 1,
            } }));
    })));
};
exports.ScrollMap = ScrollMap;
